import { useNavigate } from 'react-router-dom'
import TableFilter from './tableFilter'
import ExportButton from '../../common/ExportButton'
import { useDispatch } from 'react-redux'
import { useState } from 'react'
import { eventBookingExportColumns } from '../../config/exportColumns/eventBookingExportColumns'
import { appAllGetEventBooking } from '../../store/eventbooking'

function EventBooking() {
	const dispatch = useDispatch()
	const [exportFilters, setExportFilters] = useState({})

	const sansthaId = localStorage.getItem('sansthaId')
	const permissionOfSanstha = localStorage.getItem('permissionOfSanstha')

	return (
		<>
			<div className="content-wrapper">
				<div
					className="content-heading d-flex
                          justify-content-between"
				>
					<div>Event Booking</div>
					<div>
						<ExportButton
							fetchAction={params =>
								dispatch(
									appAllGetEventBooking({
										...params,
										...exportFilters,
										sanstha: sansthaId || permissionOfSanstha,
										page: 1,
										limit: 10000,
										loading: false,
									}),
								)
							}
							columns={eventBookingExportColumns}
							fileName="Event_Booking"
							sheetName="Event Booking"
							buttonText="Export Event Booking"
						/>
					</div>
				</div>
				<TableFilter setExportFilters={setExportFilters} />
			</div>
		</>
	)
}

export default EventBooking
